import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SurveyDataInterface } from '../../classes';
import { ReplyDataResolve, SurveyDataResolve, TimeDataResolve } from '../shared';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ReplyResolve implements Resolve<{surveyData:Partial<SurveyDataInterface>, timeData:number}> {
    constructor(
        protected surveyData:SurveyDataResolve,
        protected timeData:TimeDataResolve,
        protected replyData:ReplyDataResolve,
    ) { }
    resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): Observable<{surveyData:Partial<SurveyDataInterface>, timeData:number}> {
        return forkJoin(
            this.surveyData.resolve(route, state),
            this.timeData.resolve(route, state),
            this.replyData.resolve(route, state),
        )
        .pipe(
            map(([surveyData, timeData])=>({surveyData, timeData}))
        )
    }

}
